
  import { COOKIE_SELECTED_PRODUCT } from '@/constants/cookies';
  import { productToCookie } from '@/scripts/utils';
  import { mapGetters } from 'vuex';

  export default {
    data () {
      return { sortDirection: -1 };
    },
    computed: {
      ...mapGetters('providers', { provider: 'get' }),
      ...mapGetters('products', { allCards: 'getList' }),
      cards () {
        return this.$sortBy(this.allCards, 'monthly_cost', this.sortDirection);
      }
    },
    methods: {
      cardPath (card) {
        return `/compare-prepaid-credit-cards/${card.institution.slug}/${card.code}/${card.slug}/`;
      },
      saveToCookies (card) {
        this.$cookies.set(COOKIE_SELECTED_PRODUCT, productToCookie(card));
      }
    }
  };
